import type { GQL } from '@aline/graphql';
import { format, parseISO } from 'date-fns';
import hash from 'object-hash';

/**
 * Hashes Document content.
 */
export function hashDocumentContent(
  latestVersion:
    | Pick<GQL.DocumentVersion, 'documentJSON' | '__typename'>
    | NonNullable<Pick<GQL.StaticFileVersion, 'fileJSON' | '__typename'>>
): string {
  switch (latestVersion.__typename) {
    case 'DocumentVersion':
      return hash(latestVersion.documentJSON);
    case 'StaticFileVersion':
      return hash(latestVersion.fileJSON);
  }
}

export function getFileVersionDisplayName(
  fileVersion: Pick<GQL.FileVersion, 'createdAt' | 'name' | '__typename'>
): string {
  const dateString = format(parseISO(fileVersion.createdAt), 'MMMM d - h:mm aaa');
  return fileVersion.name || dateString;
}

export function defaultWorkflowFileSort(
  a: Pick<GQL.WorkflowFile, 'orderId'>,
  b: Pick<GQL.WorkflowFile, 'orderId'>
): number {
  const intA = parseInt(a.orderId);
  const intB = parseInt(b.orderId);

  if (a.orderId === 'certificate') return 1;
  if (b.orderId === 'certificate') return -1;
  if (isNaN(intA) || isNaN(intB)) return 0;

  return intA - intB;
}
